import { Card } from "antd";
import { forwardRef, useRef } from "react";

// export const CardUi = ({ ...rest }) => {
//   // const nodeRef = useRef(null);
//   // return (
//   //   // <Card {...props}>
//   //   //   <div ref={nodeRef}>{props?.children}</div>
//   //   // </Card>
//   // );
// };

export const CardUi = forwardRef(({ children, ...props }, ref) => {
  return (
    <Card {...props}>
      <div ref={ref}>{children}</div>
    </Card>
  );
});
